import { User } from '@/types/user';

export const roleHomePath = (role: User['role'] | undefined): '/player' | '/scouting' | '/dashboard' => {
  if (role === 'player') return '/player';
  if (role === 'scout') return '/scouting';
  return '/dashboard';
};
